import { css, styled } from 'styled-components'

import {
  StyledActionButton,
  StyledCurrentBidLabel,
  StyledInvoiceButton,
  StyledLoginButton,
  StyledMaxBidLabel,
  StyledOutbidLabelLabel,
  StyledOutbidPriceLabel,
  StyledWinningBid,
  StyledWonLotLabel,
} from '@nx/bidding-engine'
import { StyledInfoContainer } from '@nx/fire/info-box'

import { StyledBiddingContainer } from '@web/components/bidding/BiddingWidget/BiddingWidget.styles'

export const StyledBiddingWidgetWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colours.primary.white};
    padding: 20px 10px;

    ${StyledBiddingContainer} {
      border: 0;
      margin-top: 0;
      padding: 0;
    }

    ${StyledCurrentBidLabel} {
      ${theme.typography.heading.heading4}
      color: ${theme.colours.primary.primary};
      margin: 10px 0 5px;
      padding-top: 15px;
      position: relative;
      text-align: center;
      text-transform: capitalize;

      &::before {
        background-color: ${theme.colours.grey['45']};
        content: '';
        height: 1px;
        left: 50%;
        position: absolute;
        top: 0;
        transform: translateX(-50%);
        width: 80%;

        ${theme.media.up.lg} {
          width: 70%;
        }
      }
    }

    ${StyledWinningBid} {
      ${theme.typography.heading.heading4}
      color: ${theme.colours.status.success};
      text-align: center;
      text-transform: capitalize;
    }

    ${StyledMaxBidLabel} {
      ${theme.typography.heading.heading6}
      color: ${theme.colours.primary.primary};
      text-align: center;
      text-transform: capitalize;
    }

    ${StyledOutbidLabelLabel}, ${StyledOutbidPriceLabel} {
      ${theme.typography.heading.heading4}
      color: ${theme.colours.status.error};
      text-align: center;
      text-transform: capitalize;
    }

    ${StyledLoginButton}, ${StyledActionButton} {
      margin-bottom: 20px;
      text-decoration: none;
      width: 100%;
    }

    ${StyledWonLotLabel} {
      border-bottom: 0;
      color: ${theme.colours.status.success};
      margin-bottom: 20px;
      text-align: center;
    }

    ${StyledInvoiceButton} {
      width: 100%;
    }

    ${StyledInfoContainer} {
      margin: 0;
    }
  `}
`
